import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { romeDaysAgo } from "@/lib/clubTime";

const monday = (iso) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7)); return d.toISOString().slice(0, 10); };
const shift = (iso, days) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + days); return d.toISOString().slice(0, 10); };
const it = (iso) => new Date(`${iso}T12:00:00Z`).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

// Riepilogo settimanale Maestri (lun–dom, Europe/Rome): solo attività svolte, durate mancanti segnalate.
export default function WeeklyCoachSummary() {
  const [week, setWeek] = useState(() => monday(romeDaysAgo(7)));
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setData(null); setErr(false);
    api.get("/technical/weekly-coach-summary", { params: { week_start: week } }).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [week]);
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4 space-y-3" data-testid="weekly-coach-summary">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="font-semibold">Riepilogo settimanale Maestri</div>
        <button className="px-2 py-1 border rounded text-sm" data-testid="wcs-prev" onClick={() => setWeek(shift(week, -7))}>←</button>
        <span className="text-sm font-mono" data-testid="wcs-range">{it(week)} – {it(shift(week, 6))}</span>
        <button className="px-2 py-1 border rounded text-sm" data-testid="wcs-next" onClick={() => setWeek(shift(week, 7))}>→</button>
      </div>
      {!data && !err && <div className="text-sm text-zinc-500" data-testid="wcs-loading">Caricamento…</div>}
      {err && <div className="text-sm text-red-600" data-testid="wcs-error">Riepilogo non disponibile.</div>}
      {data && data.rows.length === 0 && <div className="text-sm text-zinc-500" data-testid="wcs-empty">Nessuna attività svolta registrata in questa settimana.</div>}
      {data && data.rows.length > 0 && (
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]" data-testid="wcs-table">
          <thead><tr className="text-left text-[10px] uppercase tracking-wider text-zinc-500">
            <th className="py-1">Maestro</th><th>Lezioni individuali</th><th>Minuti lezioni</th><th>Altre attività</th><th>Minuti altre</th><th>Totale minuti</th><th>Durata mancante</th></tr></thead>
          <tbody>{data.rows.map((r) => (
            <tr key={r.coach_id || "none"} className="border-t" data-testid={`wcs-row-${r.coach_id || "none"}`}>
              <td className="py-1">{r.coach_name}</td><td>{r.individual_lessons}</td><td>{r.individual_minutes}</td><td>{r.other_activities}</td>
              <td>{r.other_minutes}</td><td className="font-semibold">{r.total_minutes}</td><td className={r.missing_duration ? "text-amber-700" : ""}>{r.missing_duration}</td>
            </tr>))}</tbody>
          {data.totals && <tfoot><tr className="border-t font-semibold" data-testid="wcs-totals">
            <td className="py-1">Totale</td><td>{data.totals.individual_lessons}</td><td>{data.totals.individual_minutes}</td><td>{data.totals.other_activities}</td>
            <td>{data.totals.other_minutes}</td><td>{data.totals.total_minutes}</td><td>{data.totals.missing_duration}</td></tr></tfoot>}
        </table>
        </div>
      )}
      <div className="text-xs text-zinc-500">Conteggia solo lezioni e attività svolte; le lezioni rapide solo programmate sono escluse; le durate mancanti non vengono stimate.</div>
    </div>
  );
}
